// Sessiion managmement
export const SESSION_GET_ACTIVE_SUCCESS= "SESSION_GET_ACTIVE_SUCCESS";
export const SESSION_GET_ACTIVE_FAILED= "SESSION_GET_ACTIVE_FAILED";
export const SESSION_GET_COMPLETE="ESSION_GET_COMPLETE";
export const SESSION_CREATE="SESSION_CREATE";
export const SESSION_DELETE = "SESSION_DELETE";
export const SESSION_UPDATE_SUCCESS = "SESSION_UPDATE_SUCCESS";
export const SESSION_UPDATE_FAILED= "SESSION_UPDATE_FAILED";
export const SESSION_COMPLETE="SESSION_COMPLETE";
export const SESSION_VIEW="SESSION_VIEW";
export const SESSION_LUNCH="SESSION_LUNCH";
export const SESSION_FAILLED = "SESSION_FAILLED";
export const MIC_DATA_SUCCESS="MIC_DATA_SUCCESS";
export const MIC_DATA_FAILED="MIC_DATA_FAILED";
//End

//Profile Update(users and admin)
// export const USER_PROFILEUPDATE = "USER_PROFILEUPDATE";

// export const USER_GET_ALL = "USER_GET_ALL";
export const USER_POST = "USER_POST";
// export const USER_FAILLED = "USER_FAILLED";
export const USER_UPDATE = "USER_UPDATE";

export const PASSWORD_FAILED = "PASSWORD_FAILED";
export const PASSWORD_UPDATE = "PASSWORD_UPDATE";
//End

// User Management System 
export const USER_GET_ALL = 'USER_GET_ALL' //
export const CREATE_USER = 'CREATE_USER' //
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED'
export const USER_FAILLED = "USER_FAILLED" //
export const GET_ONE_USER = "GET_ONE_USER"
export const DELETE_USER="DELETE_USER"

//Sop Generation
export const CREATE_SOP="CREATE_SOP"
export const DOWNLOAD_SOP= "DOWNLOAD_SOP"
export const VEIW_SOP= "VEIW_SOP"
export const EDIT_SOP="EDIT_SOP"
export const FAILED_SOP="FAILED_SOP"


export const CREATE_FAQ_SUCCESS="CREATE_FAQ_SUCCESS"
export const CREATE_FAQ_FAILED="CREATE_FAQ_FAILED"

export const GET_ALL_FAQ_SUCCESS="GET_ALL_FAQ_SUCCESS"
export const GET_ALL_FAQ_FAILED="GET_ALL_FAQ_FAILED"

export const DELETE_FAQ_SUCCESS="DELETE_FAQ_SUCCESS"
export const DELETE_FAQ_FAILED="DELETE_FAQ_FAILED"

export const GET_QUESTION_SUCCESS="GET_QUESTION_SUCCESS"
export const GET_QUESTION_FAILED="GET_QUESTION_FAILED"

export const GET_QUESTION_LIST_SUCCESS="GET_QUESTION_LIST_SUCCESS"
export const GET_QUESTION_LIST_FAILED="GET_QUESTION_LIST_FAILED"


export const GET_ALL_MARKED_SUCCESS="GET_ALL_MARKED_SUCCESS"
export const GET_ALL_MARKED_FAILED="GET_ALL_MARKED_FAILED"

export const RELEVANT_SUCCESS="RELEVANT_SUCCESS"
export const RELEVANT_FAILED="RELEVANT_FAILED"

//Video mangment

export const CREATE_VIDEO_SESSION_SUCCESS="CREATE_VIDEO_SESSION_SUCCESS"
export const CREATE_VIDEO_SESSION_FAILED="CREATE_VIDEO_SESSION_FAILED"

export const FETCH_VIDEO_SESSION_SUCCESS="FETCH_VIDEO_SESSION_SUCCESS"
export const FETCH_VIDEO_SESSION_FAILED ="FETCH_VIDEO_SESSION_FAILED"

export const DELETE_VIDEO_SESSION_SUCCESS="DELETE_VIDEO_SESSION_SUCCESS"
export const DELETE_VIDEO_SESSION_FAILED ="DELETE_VIDEO_SESSION_FAILED"

export const GENERATE_IMAGE_SCRIPT_SUCCESS="GENERATE_IMAGE_SCRIPT_SUCCESS"
export const GENERATE_IMAGE_SCRIPT_FAILED ="GENERATE_IMAGE_SCRIPT_FAILED"

export const FETCH_IMAGE_SCRIPT_SUCCESS="FETCH_IMAGE_SCRIPT_SUCCESS"
export const FETCH_IMAGE_SCRIPT_FAILED ="FETCH_IMAGE_SCRIPT_FAILED"

export const DELETE_IMAGE_SCRIPT_SUCCESS="DELETE_IMAGE_SCRIPT_SUCCESS"
export const DELETE_IMAGE_SCRIPT_FAILED ="DELETE_IMAGE_SCRIPT_FAILED"

export const UPLOAD_IMAGE_REPLACEMENT_SUCCESS="UPLOAD_IMAGE_REPLACEMENT_SUCCESS"
export const UPLOAD_IMAGE_REPLACEMENT_FAILED ="UPLOAD_IMAGE_REPLACEMENT_FAILED"

export const UPDATE_SCRIPT_SUCCESS="UPDATE_SCRIPT_SUCCESS"
export const UPDATE_SCRIPT_FAILED ="UPDATE_SCRIPT_FAILED"

export const CREATE_VIDEO_INPUT_SUCCESS ="CREATE_VIDEO_INPUT_SUCCESS"
export const CREATE_VIDEO_INPUT_FAILED  ="CREATE_VIDEO_INPUT_FAILED"

export const DELETE_VIDEO_INPUT_SUCCESS ="DELETE_VIDEO_INPUT_SUCCESS"
export const DELETE_VIDEO_INPUT_FAILED  ="DELETE_VIDEO_INPUT_FAILED"

export const FETCH_VIDEO_CARD_SUCCESS="FETCH_VIDEO_CARD_SUCCESS"
export const FETCH_VIDEO_CARD_FAILED ="FETCH_VIDEO_CARD_FAILED"

//merge
export const CREATE_MERGE_SUCCESS="CREATE_MERGE_SUCCESS"
export const CREATE_MERGE_FAILED= "CREATE_MERGE_FAILED"

export const UPLOAD_VIDEO_SUCCESS="UPLOAD_VIDEO_SUCCESS"
export const UPLOAD_VIDEO_FAILED= "UPLOAD_VIDEO_FAILED"

export const FETCH_MERGE_VIDEO_SUCCESS="FETCH_MERGE_VIDEO_SUCCESS"
export const FETCH_MERGE_VIDEO_FAILED= "FETCH_MERGE_VIDEO_FAILED"

export const DELETE_MERGE_VIDEO_SUCCESS="DELETE_MERGE_VIDEO_SUCCESS"
export const DELETE_MERGE_VIDEO_FAILED= "DELETE_MERGE_VIDEO_FAILED"

export const FINAL_MERGE_VIDEO_SUCCESS="FINAL_MERGE_VIDEO_SUCCESS"
export const FINAL_MERGE_VIDEO_FAILED= "FINAL_MERGE_VIDEO_FAILED"

export const LIST_MERGE_VIDEO_SUCCESS="LIST_MERGE_VIDEO_SUCCESS"
export const LIST_MERGE_VIDEO_FAILED= "LIST_MERGE_VIDEO_FAILED"

export const DOWNLOAD_ZIP_SUCCESS="DOWNLOAD_ZIP_SUCCESS"
export const DOWNLOAD_ZIP_FAILED= "DOWNLOAD_ZIP_FAILED"

//Key / Value management

export const GET_KEY_VALUE_SUCCESS="GET_KEY_VALUE_SUCCESS"
export const GET_KEY_VALUE_FAILED= "GET_KEY_VALUE_FAILED"

export const UPDATE_KEY_VALUE_SUCCESS="UPDATE_KEY_VALUE_SUCCESS"
export const UPDATE_KEY_VALUE_FAILED ="UPDATE_KEY_VALUE_FAILED"

export const DELETE_KEY_VALUE_SUCCESS="DELETE_KEY_VALUE_SUCCESS"
export const DELETE_KEY_VALUE_FAILED= "DELETE_KEY_VALUE_FAILED"

export const CREATE_KEY_VALUE_SUCCESS="CREATE_KEY_VALUE_SUCCESS"
export const CREATE_KEY_VALUE_FAILED= "CREATE_KEY_VALUE_FAILED"

export const GET_DURATION_SUCCESS="GET_DURATION_SUCCESS"
export const GET_DURATION_FAILED= "GET_DURATION_FAILED"

export const VIDEO_ENHANCEMENT_SUCCESS="VIDEO_ENHANCEMENT_SUCCESS"
export const VIDEO_ENHANCEMENT_FAILED= "VIDEO_ENHANCEMENT_FAILED"

export const DELETE_MERGE_LIST_SUCCESS="DELETE_MERGE_LIST_SUCCESS"
export const DELETE_MERGE_LIST_FAILED= "DELETE_MERGE_LIST_FAILED"

export const REGENERATE_MERGE_LIST_SUCCESS="REGENERATE_MERGE_LIST_SUCCESS"
export const REGENERATE_MERGE_LIST_FAILED= "REGENERATE_MERGE_LIST_FAILED"

export const REGENERATE_UPLOAD_SUCCESS="REGENERATE_UPLOAD_SUCCESS"
export const REGENERATE_UPLOAD_FAILED= "REGENERATE_UPLOAD_FAILED"

export const REARRANGE_VIDEOS_SUCCESS="REARRANGE_VIDEOS_SUCCESS"
export const REARRANGE_VIDEOS_FAILED= "REARRANGE_VIDEOS_FAILED"